var map = {
	"./hero-bg-1200.jpg": 2015,
	"./hero-bg-1200.webp": 2016,
	"./hero-bg-1200x2.jpg": 2017,
	"./hero-bg-1200x2.webp": 2018,
	"./hero-bg-1600.jpg": 2019,
	"./hero-bg-1600.webp": 2020,
	"./hero-bg-1600x2.jpg": 2021,
	"./hero-bg-1600x2.webp": 2022,
	"./hero-bg-1920.jpg": 2023,
	"./hero-bg-1920.webp": 2024,
	"./hero-bg-1920x2.jpg": 2025,
	"./hero-bg-1920x2.webp": 2026,
	"./hero-bg-2560.jpg": 2027,
	"./hero-bg-2560.webp": 2028,
	"./hero-bg-580.jpg": 2029,
	"./hero-bg-580.webp": 2030,
	"./hero-bg-580x2.jpg": 2031,
	"./hero-bg-580x2.webp": 2032,
	"./hero-bg-800.jpg": 2033,
	"./hero-bg-800.webp": 2034,
	"./hero-bg-800x2.jpg": 2035,
	"./hero-bg-800x2.webp": 2036,
	"./hero-bg-full.jpg": 2037,
	"./hero-bg-full.webp": 2038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2014;